import React, { useState, useEffect } from "react";
import axios from "axios";
import CircularProgress from '@mui/material/CircularProgress';

const Scheduler_Execute = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [runningTitle, setRunningTitle] = useState(null);      
  const [msg, setMsg] = useState(null);
  const [executedTitles, setExecutedTitles] = useState(new Set());   

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/api/scheduler/schedularlist`);
      setItems(res.data || []);
    } catch (err) {
      setMsg({ type: "error", text: "Could not load scheduler list" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRun = async (title) => {
    if (!title) return;
    
    if (!window.confirm(`Execute: ${title}`)) return;

    setRunningTitle(title);
    setMsg(null);

    try {
      await axios.post(`${process.env.REACT_APP_URL}/api/scheduler/run`, {
        functionTitle: title                    
      });

      setExecutedTitles(prev => {
        const newSet = new Set(prev);
        newSet.add(title);
        return newSet;
      });

      setMsg({ type: "success", text: "Executed successfully" });
      await fetchData();   
    } catch (err) {
      let text = "Execution failed";
      if (err.response?.data) {
        text = typeof err.response.data === 'string' 
          ? err.response.data 
          : err.response.data.message || "Execution failed";
      }
      setMsg({ type: "error", text });
    } finally {
      setRunningTitle(null);
    }
  };

  return (
    <>
      <br /><br />
      <table width="60%" align="center">
        <tr className="tableheader">
          <td colSpan={4}>SCHEDULAR EXECUTE</td>
        </tr>

        <tr className="tableheader">
          <td>SL.NO</td>
          <td>Title</td>
          <td>Action</td>
          <td>Updated Time</td>
        </tr>

        {items.map((row, idx) => {
          const isDone = executedTitles.has(row.title);         
          const isRunning = runningTitle === row.title;

          return (
            <tr key={row.id}>   
              <td>{idx + 1}</td>
              <td>{row.title || "—"}</td>
              <td  align="center">
                {isDone ? (
                  <span style={{ color: "green", fontWeight: "bold" }}>Done</span>
                ) : (
                  <button
                    onClick={() => handleRun(row.title)}
                    disabled={isRunning || loading || !row.title}
                    className="button button2"
                  >
                    Execute
                  </button>
                )}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "10px", textAlign: "center" }}>
                {row.updated_time || "—"}
              </td>
            </tr>
          );
        })}

        {items.length === 0 && !loading && (
          <tr>
            <td colSpan={4} style={{ padding: "20px", textAlign: "center" }}>
              No schedulers configured
            </td>
          </tr>
        )}
      </table>

      {loading && (
        <div align="center" style={{ marginTop: "15px" }}>
          <CircularProgress />
        </div>
      )}

      {msg && (
        <p
          style={{
            textAlign: "center",
            margin: "20px 0",
            color: msg.type === "error" ? "#d32f2f" : "#2e7d32",
            fontWeight: "600",
            fontSize: "20px",
            
          }}
        >
          {msg.text}
        </p>
      )}
    </>
  );
};

export default Scheduler_Execute;